import {UISTATES, KEYCODES} from '../enum';
import {getPreviousResultIndex, getNextResultIndex} from './resultsNavigator';

function finishEvent(event) {
    event.preventDefault();
    event.stopPropagation();
}

function handleEnter({uistate}, ev) {
    finishEvent(ev);
    return uistate === UISTATES.SELECT_DESTINATION;
}

function handleUp(state, ev) {
    const {uistate, selectDestinationIndex, results} = state;

    finishEvent(ev);

    if (uistate === UISTATES.SELECT_DESTINATION) {
        return getPreviousResultIndex(results, selectDestinationIndex);
    }
    return false;
}

function handleDown(state, ev) {
    const {uistate, selectDestinationIndex, results} = state;

    finishEvent(ev);

    if (uistate === UISTATES.CLOSED) {
        return {uistate: UISTATES.SELECT_DESTINATION};
    }
    if (uistate === UISTATES.SELECT_DESTINATION) {
        return getNextResultIndex(results, selectDestinationIndex);
    }
    return false;
}

function handleRight({uistate}, ev) {
    if (uistate === UISTATES.SELECT_DESTINATION) {
        if (
            ev.target &&
            ev.target.value &&
            ev.target.value.length === ev.target.selectionStart
        ) {
            return true;
        }
    }
    return false;
}

/**
 * keypress()
 * Process keypress event
 * @param {*} state
 * @param {*} ev
 */
/* eslint-disable complexity */
export function keypress(state = {}, ev = {}) {
    const {keyCode} = ev;
    switch (keyCode) {
        case KEYCODES.ESCAPE:
            return {uistate: UISTATES.CLOSED};
        case KEYCODES.ENTER:
            return handleEnter(state, ev);
        case KEYCODES.UP:
            return handleUp(state, ev);
        case KEYCODES.DOWN:
            return handleDown(state, ev);
        case KEYCODES.RIGHT:
            return handleRight(state, ev);
        default:
            return false;
    }
}
/* eslint-enable complexity */

/**
 * isTabOutsideTypeahead()
 * Check if tab was clicked and next tabable element is not in typeahead component
 * @param {*} state
 * @param {*} ev
 */
/* eslint-disable complexity */
export function isTabOutsideTypeahead(state = {}, ev = {}) {
    if (ev.keyCode === KEYCODES.TAB) {
        const elemClassName =
            typeof ev.target.className === 'string' ? ev.target.className : '';
        if (
            !ev.shiftKey &&
            elemClassName.indexOf('search-destination-input__close') !== -1
        ) {
            return true;
        }

        if (!state.search) {
            if (
                elemClassName.indexOf('result') !== -1 ||
                ev.target.id === 'react-destination-typeahead'
            ) {
                return true;
            }
        }
    }
    return false;
}
/* eslint-enable complexity */
